import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Field, Form, RadioGroup, Select, Textarea } from "@/ui";
import type { CaptureDraft, CaptureTarget } from "./captureDraft";

type Option = { value: string; label: string; hint?: string };
interface Props { draft: CaptureDraft; errors: Errors<CaptureDraft>; set: <K extends keyof CaptureDraft>(k: K, v: CaptureDraft[K]) => void; accounts: Option[]; channels: Option[] }

/** 新建抓包任务的字段（决策 D93）：客户账号抓 smpp-server 上它的全部 bind，供应商通道抓 smpp-connector 上它的全部 bind。 */
export function CaptureForm({ draft, errors, set, accounts, channels }: Props) {
  return (
    <Form>
      <Field label="抓包对象" required>
        <RadioGroup<CaptureTarget> name="capture-target" value={draft.target} onChange={(v) => set("target", v)} options={[
          { value: "account", label: "客户账号", description: "客户连到网关的 SMPP 会话，这个账号的 bind 都抓（改名前已连上的也算）" },
          { value: "channel", label: "供应商通道", description: "网关连到上游的 SMPP 会话，这条通道的 bind 都抓" },
        ]} />
      </Field>
      {draft.target === "account" ? (
        <Field label="客户账号" required error={errors.account_id} hint="只列 SMPP 账号">
          <Select block options={accounts} value={draft.account_id || null} placeholder="选择客户账号" onChange={(v) => set("account_id", v)} invalid={!!errors.account_id} />
        </Field>
      ) : (
        <Field label="供应商通道" required error={errors.channel_id} hint="只列 SMPP 通道">
          <Select block options={channels} value={draft.channel_id || null} placeholder="选择供应商通道" onChange={(v) => set("channel_id", v)} invalid={!!errors.channel_id} />
        </Field>
      )}
      <TextField id="cap-minutes" label="时长（分钟）" required mono value={draft.minutes} error={errors.minutes} hint="到期自动停止，最长 60 分钟" onChange={(v) => set("minutes", v.trim())} />
      <TextField id="cap-max" label="最多抓多少个 PDU" required mono value={draft.max_packets} error={errors.max_packets} hint="达到后不再记录，最多 10 万" onChange={(v) => set("max_packets", v.trim())} />
      <Field label="备注" htmlFor="cap-note"><Textarea id="cap-note" rows={2} value={draft.note} onChange={(e) => set("note", e.target.value)} /></Field>
    </Form>
  );
}
